import { render, staticRenderFns } from "./EditarClienteExtraCostoModal.vue?vue&type=template&id=1cbb8ea6"
import script from "./EditarClienteExtraCostoModal.vue?vue&type=script&lang=js"
export * from "./EditarClienteExtraCostoModal.vue?vue&type=script&lang=js"
import style0 from "./EditarClienteExtraCostoModal.vue?vue&type=style&index=0&id=1cbb8ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports